import { useQuery, useMutation } from "@tanstack/react-query";
import { api } from "@/utils/axiosInterceptor";
import { BuyerFormData, BuyersType } from "@/types/buyer";
import { buyerSchema, newBuyerSchema } from "@/schema/schema";
import { z } from "zod";

export const useBuyers = () => {
	const {
		data: buyers,
		isLoading,
		isLoadingError,
		error,
	} = useQuery({
		queryKey: ["buyers"],
		queryFn: async () => {
			const response = await api.get<BuyersType>("/buyers")
			return response.data;
		},
	});

	const createBuyerMutation = useMutation({
		mutationFn: (buyer: z.infer<typeof newBuyerSchema>) => api.post<z.infer<typeof buyerSchema>>("/buyer", buyer),
	});

	const updateBuyerMutation = useMutation({
		mutationFn: (buyer: {id: string | undefined, body: Omit<BuyerFormData, "id">}) =>
			api.put<BuyerFormData>(`/buyer/${buyer.id}`, buyer.body),
	});

	const deleteBuyerMutation = useMutation({
		mutationFn: (id: string) => api.delete(`/buyer/${id}`),
	});

	return {
		buyers,
		createBuyerAsync: createBuyerMutation.mutateAsync,
		isCreating: createBuyerMutation.isPending,
		updateBuyer: updateBuyerMutation.mutateAsync,
		isUpdating: updateBuyerMutation.isPending,
		deleteBuyerAsync: deleteBuyerMutation.mutateAsync,
		isLoading,
		isLoadingError,
		error,
	};
};
